import { required, email, integer } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("requiredarray", {
  validate(value) {
    console.log(value);
    return value && value.length > 0;
  },
  message: "Este campo es requerido",
});

extend("required", {
  ...required,
  message: "Este campo es requerido",
});

extend("required-check", {
  validate(value) {
    return value === true;
  },
  message: "Este campo es requerido",
});

extend("email", {
  ...email,
  message: "Email invalido",
});

extend("positive", {
  validate(value) {
    return value > 0;
  },
  message: "Este valor debe ser mayor a cero",
});
extend("integer", {
  ...integer,
  message: "Este campo debe ser entero",
});

extend("odd", (value) => {
  return value % 2 !== 0;
});

extend("min", {
  validate(value, args) {
    return value.length >= args.length;
  },
  params: ["length"],
  message: "Debe tener al menos {length} caracteres",
});

extend("max", {
  validate(value, args) {
    return value.length <= args.length;
  },
  params: ["length"],
});

extend("size", {
  validate(value, args) {
    return (
      value
        .toString()
        .replaceAll(" ", "")
        .replaceAll("-", "").length === parseInt(args.length)
    );
  },
  params: ["length"],
  message: "Debe tener {length} caracteres",
});

extend("phone", {
  validate(value) {
    return (
      value
        .toString()
        .replaceAll(" ", "")
        .replaceAll("-", "").length === 10
    );
  },
  message: "Debe tener 10 caracteres",
});

extend("code", {
  validate(value, args) {
    if (value) {
      return (
        value.toString().replaceAll(" ", "").length === parseInt(args.length)
      );
    } else {
      return false;
    }
  },
  params: ["length"],
  message: "Código inválido",
});

extend("requiredcode", {
  validate(value) {
    return value.toString().replaceAll(" ", "").length > 0;
  },
  message: "Código es requerido",
});
extend("percentage_valid", (value) => {
  let resp = true;
  const num_str = value.toString().split(".");
  if (value < 0 || value > 100) resp = "Se aceptan valores entre 0 y 100";
  if (num_str && num_str.length > 1 && num_str[1].length > 1)
    resp = "Solo se acepta 1 decimal";
  return resp;
});
extend('numberpositivo', {
    validate: value => {
      return value > 0;
    },
    message: 'El campo debe ser mayor a 0.'
  });

extend('without_decimals', {
  validate: value => {
    return value % 1 === 0;
  },
  message: 'El valor no debe tener decimales'
});

extend("non_negative", {
  validate: value => {
    return Number(value) >= 0;
  },
  message: "El valor no puede ser negativo."
});